import Text from 'components/shared/Text'
import {
    VoucherPreviewCopy,
    VoucherPreviewDate,
    VoucherPreviewHks,
    VoucherPreviewTitle,
    VoucherPreviewWrapper,
    VoucherPreviewInfo,
    VoucherPreviewQRCode,
    VoucherPreviewLeft,
    VoucherPreviewRight,
    VoucherPreviewLeftWrapper,
} from './styles'
import Box from 'components/shared/Box'
import QRCode from 'assets/images/voucher/qrcode.png'
import TriLogo from 'assets/images/voucher/tri-logo-new.svg'
import Decor from 'assets/images/voucher/sun_palms.svg'
import { formatPrice } from 'helpers/helpers'
import moment from 'moment'
import { useIntl } from 'react-intl'

interface AmountVoucherProps {
    voucherSignature: string
    unitPrice: number
}

export const AmountVoucher = ({
    voucherSignature,
    unitPrice,
}: AmountVoucherProps) => {
    const { formatMessage } = useIntl()
    const date = moment().add(366, 'days').format('DD.MM.YYYY')

    return (
        <Box gap={4}>
            <Text variant="bodySmall" color="grayscale_900">
                {formatMessage({
                    id: 'selfcare.payment.personalize_voucher_preview_label',
                    defaultMessage: 'Podgląd Vouchera',
                })}
            </Text>
            <VoucherPreviewWrapper direction={'row'}>
                <VoucherPreviewLeft
                    pt={[16, 20]}
                    pb={2}
                    isFullWidth
                    align={'center'}
                    justify={'space-between'}
                >
                    <VoucherPreviewLeftWrapper isFullWidth>
                        <VoucherPreviewTitle
                            variant="heading4"
                            color="grayscale_900"
                            align={'center'}
                        >
                            Voucher
                            {` ${formatPrice(unitPrice)} zł`}
                        </VoucherPreviewTitle>
                        <VoucherPreviewDate
                            variant="heading5"
                            color="grayscale_900"
                            align="center"
                        >
                            {`ważny do ${date} r.`}
                        </VoucherPreviewDate>
                        <VoucherPreviewHks
                            variant="heading5"
                            color="grayscale_900"
                            align="center"
                        >
                            FBV12345123451234512345
                        </VoucherPreviewHks>
                    </VoucherPreviewLeftWrapper>

                    <VoucherPreviewQRCode gap={3} isFullWidth>
                        <img src={QRCode} alt="" />
                        <VoucherPreviewInfo
                            variant="bodyExtraSmall"
                            color="grayscale_900"
                        >
                            Voucher zakupiony na stronie www.parkofpoland.com
                        </VoucherPreviewInfo>
                    </VoucherPreviewQRCode>
                </VoucherPreviewLeft>
                <VoucherPreviewRight justify={'space-between'} align={'center'}>
                    <Box minWidth={110} mb={[0, 2]} pl={10} pr={10}>
                        <img src={TriLogo} alt="Suntago - Samsung - Pepsi" />
                    </Box>
                    <VoucherPreviewCopy
                        variant="bodyStrong"
                        color="grayscale_900"
                        align={'center'}
                        as="pre"
                    >
                        {voucherSignature}
                    </VoucherPreviewCopy>
                    <Box minWidth={123} justify={'flex-end'}>
                        <img src={Decor} alt="" />
                    </Box>
                </VoucherPreviewRight>
            </VoucherPreviewWrapper>
        </Box>
    )
}
